import { useCallback } from 'react';

import { useLazyScript } from '@/hooks/useScript';

import { USERPILOT_URL } from '@/constants/env';

/**
 * usePreloadUserpilot: Returns a function that can be used to programmatically load Userpilot
 */
export function usePreloadUserpilot() {
  const [loadScript] = useLazyScript(USERPILOT_URL, {
    crossOrigin: undefined,
  });

  return useCallback(async () => {
    if (RUNTIME_ENV === 'native') {
      return;
    }
    try {
      await loadScript();
    } catch (error: unknown) {
      console.error('Userpilot: Failed to preload', error);
    }
  }, [loadScript]);
}
